import React from "react";
import moment from "moment";

const Badge = ({ value }) => {
  return value ? (
    <span className="badge bg-label-success me-1">
      <i className="menu-icon tf-icons bx bx-check" />
    </span>
  ) : (
    <span className="badge bg-label-danger me-1">
      <i className="menu-icon tf-icons bx bx-x" />
    </span>
  );
};

const TabelaPagamentos = ({ data = [] }) => {
  const listaOrdenada = [...data].sort((a, b) =>
    moment(b.dataPagamento).diff(moment(a.dataPagamento))
  );

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Ordem</th>
          <th>Free</th>
          <th>Vip</th>
          <th>Cupom</th>
          <th>Atleta</th>
          <th>CPF</th>
          <th>Email</th>
          <th>Valor</th>
          <th>Desconto</th>
          <th>Total</th>
          <th>Data Pagamento</th>
        </tr>
      </thead>

      <tbody className="table-border-bottom-0">
        {listaOrdenada.length > 0 ? (
          listaOrdenada.map((pagamento, index) => {
            const desconto = parseFloat(pagamento.desconto ?? 0);
            const total = pagamento.valor - desconto;

            return (
              <tr key={index}>
                <td>{pagamento.numero}</td>

                <td>
                  <Badge value={pagamento.free === "SIM"} />
                </td>

                <td>
                  <Badge value={pagamento.salaVip} />
                </td>

                <td>
                  {pagamento.idCupom ? (
                    pagamento.cupom
                  ) : (
                    <span className="badge bg-label-danger me-1">
                      <i className="menu-icon tf-icons bx bx-x" />
                    </span>
                  )}
                </td>

                <td>{pagamento.nomeUsuario}</td>
                <td>{pagamento.cpf}</td>
                <td>{pagamento.email}</td>

                <td>
                  {pagamento.valor.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>

                <td>
                  {desconto.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>

                <td>
                  {total.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </td>

                <td>
                  {pagamento.dataPagamento
                    ? moment(pagamento.dataPagamento).format(
                        "DD/MM/YYYY - HH:mm"
                      )
                    : "Free"}
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="11" style={{ textAlign: "center", padding: 10 }}>
              Sem pagamentos
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default TabelaPagamentos;